import { useEffect, useRef, useState } from "react";
import BarraProgreso from "../BarraProgreso/BarraProgreso";
import "./TemporizadorActualizar.css"

const TemporizadorActualizar = ({ onChange }) => {
  const intervalRef = useRef(null);
  const [timer, setTimer] = useState("00");

  const getTimeRemaining = (endtime) => {
    const total = Date.parse(new Date()); // Date.parse(endtime) -
    const seconds = Math.floor((total / 1000) % 60);
    return { total, seconds };
  };

  const starTimer = (deadline) => {
    const { total, seconds } = getTimeRemaining(deadline);
    if (total >= 0) {
      setTimer(seconds > 9 ? seconds : "0" + seconds);
    } else {
      clearInterval(intervalRef.current);
    }
  };

  const clearTime = (endtime) => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    const id = setInterval(() => {
      starTimer(endtime);
    }, 1000);
    intervalRef.current = id;
  };

  const getDeadlineTime = () => {
    const deadline = new Date();
    deadline.setSeconds(deadline.getSeconds() + 60);
    return deadline;
  };

  useEffect(() => {
    clearTime(getDeadlineTime());
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (timer === "00") {
      clearTime(getDeadlineTime());
      onChange();
    }
    //eslint-disable-next-line
  }, [timer]);

  return (
    <>
      <div className="tokenbox-body-barra-progreso">
        <BarraProgreso width={260} porcentaje={(60 - +timer) / 60} />
      </div>
      <div className="tokenbox-container-temporizador">
        <div className="tokenbox-temporizador">
          <span className="tokenbox-temporizador-reloj rbm14l c-black noSeleccionable">
            {60 - +timer}
          </span>
          <span className="tokenbox-temporizador-text rbm14l c-black noSeleccionable">
            seg restantes
          </span>
        </div>
      </div>
    </>
  );
};

export default TemporizadorActualizar;
